import { render, staticRenderFns } from "./QuotationEmail.vue?vue&type=template&id=5fd20015&"
import script from "./QuotationEmail.vue?vue&type=script&lang=js&"
export * from "./QuotationEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports